module.exports = __webpack_public_path__ + "static/media/contact-whatsapp.29908ddd.svg";